import { LocaleButtonGroup } from './view';
export default LocaleButtonGroup;
